import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SucculentList } from './pages/SucculentList';
import { SucculentDetail } from './pages/SucculentDetail';
import { PublicList } from './pages/PublicList';
import { Setting } from './pages/Setting';
import { SetUserInfo } from './pages/SetUserInfo';
import { AuthCallback } from './components/AuthCallback';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SucculentList />} />
        <Route path="/succulents/:id" element={<SucculentDetail />} />
        <Route path="/public" element={<PublicList />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/profile" element={<SetUserInfo />} />
        <Route path="/callback" element={<AuthCallback />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
